import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import ISize from '../../interfaces/ISize'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { sizeList } from '../../services/api'

interface SizeContextState extends BaseContextState {
  sizes: Array<ISize> | null
}

export interface SizeContextData extends SizeContextState {
  resetErrors: Function,
  requestSizeList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as SizeContextData)

// Export consumer
export const SizeConsumer = Consumer

export class SizeProvider extends BaseContextProvider {
  state: SizeContextState = {
    sizes: null
  }

  /**
   * Make api request for size list
   * 
   * @param {SearchRequest} payload 
   */
  requestSizeList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await sizeList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'sizes'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestSizeList: this.requestSizeList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
